import React from "react"
import "core-js/es7/array"
import ReactDOM from "react-dom"
import App from "./App"
import registerServiceWorker from "./registerServiceWorker"
import "core-js/fn/string/includes"
ReactDOM.render(<App />, document.getElementById("root"))
registerServiceWorker()
